<div class="block w-full" [formGroup]="form">
    <label>{{ formItem.name }}</label>
    <ng-container [ngSwitch]="type">
        <div class="w-full block" *ngSwitchCase="'text'">
            <input type="text" placeholder="Escriba aquí..." class="block w-full py-2 px-4 text-base border rounded" [formControlName]="formItem.label">
        </div>
        <div class="w-full block" *ngSwitchCase="'select'">
            <select class="block w-full py-2 px-4 text-base border rounded" [formControlName]="formItem.label">
                <option selected [ngValue]="null">Please select</option>
                <option [ngValue]="option.key"
                        *ngFor="let option of formItem.selectOptions | keyvalue">
                        {{ option.value }}
                </option>
            </select>
        </div>
    </ng-container>
    
</div>